module.exports = __webpack_public_path__ + "static/media/brand-refresh-arrow-left.d1f98ada.svg";